import { UTM_PARAMS } from './types';

/* eslint-disable import/prefer-default-export */
export const utmParamsAction = (utmTags) => ({
    type: UTM_PARAMS,
    payload: utmTags,
});
/* eslint-enable import/prefer-default-export */



/** WEBPACK FOOTER **
 ** ./src/redux/actions/utm-params.js
 **/